import React, { useState } from "react";
import { Search, X } from "lucide-react";
import "../style/StationSearch.css";
import { YELLOW_STATIONS } from "../stations/yellowStations";

const StationSearch = ({ theme = "light", language = "en", mapInstance }) => {
	const [query, setQuery] = useState("");
	const [focused, setFocused] = useState(false);

	// Filter stations by name in selected language
	const results = YELLOW_STATIONS.filter((station) => {
		const name =
			language === "kn"
				? station.name_kn
				: language === "hi"
					? station.name_hi
					: station.name;
		return name.toLowerCase().includes(query.toLowerCase());
	});

	const handleSelect = (station) => {
		setQuery("");
		setFocused(false);

		if (mapInstance && typeof mapInstance.flyTo === "function") {
			mapInstance.flyTo({
				center: [station.lng, station.lat],
				zoom: 14,
				speed: 0.5,
				curve: 1.6,
				duration: 1000,
				essential: true,
			});

			mapInstance.once("moveend", () => {
				if (window.showYellowStationPopup) {
					window.showYellowStationPopup(station.name);
					return;
				}

				const lngLat = { lng: station.lng, lat: station.lat };
				const point = mapInstance.project([station.lng, station.lat]);
				const fire = () => {
					mapInstance.fire("click", {
						point,
						lngLat,
						originalEvent: new MouseEvent("click"),
					});
				};

				const layerId = "yellow-stations-layer";
				const hasFeature =
					mapInstance.queryRenderedFeatures(point, { layers: [layerId] }).length > 0;

				if (hasFeature) fire();
				else setTimeout(fire, 120);
			});
		}
	};

	const clearSearch = () => {
		setQuery("");
		setFocused(false);
	};

	return (
		<div className={`search-container ${theme} ${focused ? "focused" : ""}`}>
			<Search size={18} strokeWidth={2} />

			<input
				type="text"
				placeholder={
					language === "kn"
						? "ನಿಲ್ದಾಣ ಹುಡುಕಿ..."
						: language === "hi"
							? "स्टेशन खोजें..."
							: "Search station..."
				}
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				onFocus={() => {
					setFocused(true);
					if (window.currentYellowPopup && typeof window.currentYellowPopup.remove === "function") {
						window.currentYellowPopup.remove();
						window.currentYellowPopup = null;
					}
				}}
				onBlur={() => setFocused(false)}
			/>

			{/* ✅ Clear button (X) */}
			{query && (
				<X
					size={16}
					className="clear-btn"
					onMouseDown={clearSearch}
					style={{ cursor: "pointer" }}
				/>
			)}

			{query && (
				<ul className="search-results">
					{results.length > 0 ? (
						results.map((station) => {
							const name =
								language === "kn"
									? station.name_kn
									: language === "hi"
										? station.name_hi
										: station.name;
							return (
								<li
									key={station.station_id}
									onMouseDown={() => handleSelect(station)}
								>
									{name}
								</li>
							);
						})
					) : (
						<li className="no-results">
							{language === "kn"
								? "ಯಾವುದೇ ನಿಲ್ದಾಣ ಕಂಡುಬಂದಿಲ್ಲ"
								: language === "hi"
									? "कोई स्टेशन नहीं मिला"
									: "No station found"}
						</li>
					)}
				</ul>
			)}
		</div>
	);
};

export default StationSearch;
